module.exports = __webpack_public_path__ + "autosaw.png?9f1b046e47fa80b518295ac43e4d930d";